//AR RESIDENCE:
import r1Img1 from "../assets/projects/ar_residence/img1.webp";
import r1Img2 from "../assets/projects/ar_residence/img2.webp";
import r1Img3 from "../assets/projects/ar_residence/img3.webp";

//CHANDRA STORES
import r2Img1 from "../assets/projects/chandra_stores/img1.webp";
import r2Img2 from "../assets/projects/chandra_stores/img2.webp";
import r2Img3 from "../assets/projects/chandra_stores/img3.webp";
import r2Img4 from "../assets/projects/chandra_stores/img4.webp";
import r2Img5 from "../assets/projects/chandra_stores/img5.webp";
import r2Img6 from "../assets/projects/chandra_stores/img6.webp";
import r2Img7 from "../assets/projects/chandra_stores/img7.webp";
import r2Img8 from "../assets/projects/chandra_stores/img8.webp";
import r2Img9 from "../assets/projects/chandra_stores/img9.webp";

//COIMBATORE ELEVATION
import r3Img1 from "../assets/projects/coimbatore/img1.webp";
import r3Img2 from "../assets/projects/coimbatore/img2.webp";
import r3Img4 from "../assets/projects/coimbatore/img4.webp";
import r3Img5 from "../assets/projects/coimbatore/img5.webp";
import r3Img6 from "../assets/projects/coimbatore/img6.webp";

//EGMORE LIVING
import r4Img1 from "../assets/projects/egmore_living/img1.webp";
import r4Img2 from "../assets/projects/egmore_living/img2.webp";
import r4Img3 from "../assets/projects/egmore_living/img3.webp";
import r4Img4 from "../assets/projects/egmore_living/img4.webp";

//GAVIN RESIDENCE
import r5Img1 from "../assets/projects/gavin_res/img1.webp";
import r5Img2 from "../assets/projects/gavin_res/img2.webp";
import r5Img3 from "../assets/projects/gavin_res/img3.webp";
import r5Img4 from "../assets/projects/gavin_res/img4.webp";
import r5Img5 from "../assets/projects/gavin_res/img5.webp";
import r5Img6 from "../assets/projects/gavin_res/img6.webp";
import r5Img7 from "../assets/projects/gavin_res/img7.webp";
import r5Img8 from "../assets/projects/gavin_res/img8.webp";
import r5Img9 from "../assets/projects/gavin_res/img9.webp";
import r5Img10 from "../assets/projects/gavin_res/img9.webp";

//NAM ILLAM TIRCHY
import r6Img1 from "../assets/projects/nam_illam_tirchy/img1.webp";
import r6Img2 from "../assets/projects/nam_illam_tirchy/img2.webp";
import r6Img3 from "../assets/projects/nam_illam_tirchy/img3.webp";
import r6Img4 from "../assets/projects/nam_illam_tirchy/img4.webp";
import r6Img5 from "../assets/projects/nam_illam_tirchy/img5.webp";
import r6Img6 from "../assets/projects/nam_illam_tirchy/img6.webp";
import r6Img7 from "../assets/projects/nam_illam_tirchy/img7.webp";
import r6Img8 from "../assets/projects/nam_illam_tirchy/img8.webp";
import r6Img9 from "../assets/projects/nam_illam_tirchy/img9.webp";
import r6Img10 from "../assets/projects/nam_illam_tirchy/img10.webp";
import r6Img11 from "../assets/projects/nam_illam_tirchy/img11.webp";
import r6Img12 from "../assets/projects/nam_illam_tirchy/img12.webp";
import r6Img13 from "../assets/projects/nam_illam_tirchy/img13.webp";

//PANDIAN RESIDENCE
import r7Img1 from "../assets/projects/pandian_res/img1.webp";
import r7Img2 from "../assets/projects/pandian_res/img2.webp";
import r7Img3 from "../assets/projects/pandian_res/img3.webp";
import r7Img4 from "../assets/projects/pandian_res/img4.webp";
import r7Img5 from "../assets/projects/pandian_res/img5.webp";
import r7Img6 from "../assets/projects/pandian_res/img6.webp";
import r7Img7 from "../assets/projects/pandian_res/img7.webp";
import r7Img8 from "../assets/projects/pandian_res/img8.webp";
import r7Img9 from "../assets/projects/pandian_res/img9.webp";
import r7Img10 from "../assets/projects/pandian_res/img10.webp";

//RAJA VILLA
import r8Img1 from "../assets/projects/raja_villa/img1.webp";
import r8Img2 from "../assets/projects/raja_villa/img2.webp";
import r8Img3 from "../assets/projects/raja_villa/img3.webp";
import r8Img4 from "../assets/projects/raja_villa/img4.webp";
import r8Img5 from "../assets/projects/raja_villa/img5.webp";
import r8Img6 from "../assets/projects/raja_villa/img6.webp";
import r8Img7 from "../assets/projects/raja_villa/img7.webp";
import r8Img8 from "../assets/projects/raja_villa/img8.webp";
import r8Img9 from "../assets/projects/raja_villa/img9.webp";
import r8Img10 from "../assets/projects/raja_villa/img10.webp";
import r8Img11 from "../assets/projects/raja_villa/img11.webp";
import r8Img12 from "../assets/projects/raja_villa/img12.webp";

///OFFICE SPACE

//ELEVATE STUDIOS
import o1Img1 from "../assets/projects/elevate_studios/img1.webp";
import o1Img2 from "../assets/projects/elevate_studios/img2.webp";
import o1Img3 from "../assets/projects/elevate_studios/img3.webp";
import o1Img4 from "../assets/projects/elevate_studios/img4.webp";
import o1Img5 from "../assets/projects/elevate_studios/img5.webp";
import o1Img6 from "../assets/projects/elevate_studios/img6.webp";
import o1Img7 from "../assets/projects/elevate_studios/img7.webp";
import o1Img8 from "../assets/projects/elevate_studios/img8.webp";
import o1Img9 from "../assets/projects/elevate_studios/img9.webp";
import o1Img10 from "../assets/projects/elevate_studios/img10.webp";
import o1Logo from "../assets/projects/elevate_studios/logo.webp";

//MIRACLE WEDDING
import o2Img1 from "../assets/projects/miracle_wedding/img1.webp";
import o2Img2 from "../assets/projects/miracle_wedding/img2.webp";
import o2Img3 from "../assets/projects/miracle_wedding/img3.webp";
import o2Img4 from "../assets/projects/miracle_wedding/img4.webp";
import o2Img5 from "../assets/projects/miracle_wedding/img5.webp";
import o2Img6 from "../assets/projects/miracle_wedding/img6.webp";
import o2Img7 from "../assets/projects/miracle_wedding/img7.webp";
import o2Logo from "../assets/projects/miracle_wedding/logo.webp";

//STILT OFFICE
import o3Img1 from "../assets/projects/stilt_office/img1.webp";
import o3Img2 from "../assets/projects/stilt_office/img2.webp";
import o3Img3 from "../assets/projects/stilt_office/img3.webp";
import o3Img4 from "../assets/projects/stilt_office/img4.webp";
import o3Img5 from "../assets/projects/stilt_office/img5.webp";
import o3Img6 from "../assets/projects/stilt_office/img6.webp";
import o3Img7 from "../assets/projects/stilt_office/img7.webp";

///COMMERCIAL

//EXPERIENCE CENTER
import c1Img1 from "../assets/projects/experience_center/img1.webp";
import c1Img2 from "../assets/projects/experience_center/img2.webp";
import c1Img3 from "../assets/projects/experience_center/img3.webp";
import c1Img4 from "../assets/projects/experience_center/img4.webp";
import c1Img5 from "../assets/projects/experience_center/img5.webp";

//FAYAZ RES
import c2Img1 from "../assets/projects/fayaz_res/img1.webp";
import c2Img2 from "../assets/projects/fayaz_res/img2.webp";
import c2Img3 from "../assets/projects/fayaz_res/img3.webp";
import c2Img4 from "../assets/projects/fayaz_res/img4.webp";

//FEALZ
import c3Img1 from "../assets/projects/fealz/img1.webp";
import c3Img2 from "../assets/projects/fealz/img2.webp";
import c3Img3 from "../assets/projects/fealz/img3.webp";
import c3Img4 from "../assets/projects/fealz/img4.webp";
import c3Img5 from "../assets/projects/fealz/img5.webp";
import c3Img6 from "../assets/projects/fealz/img6.webp";
import c3Img7 from "../assets/projects/fealz/img7.webp";
import c3Img8 from "../assets/projects/fealz/img8.webp";
import c3Img9 from "../assets/projects/fealz/img9.webp";

//GLOBAL CRITICAL CARE
import c4Img1 from "../assets/projects/global_care/img1.webp";
import c4Img2 from "../assets/projects/global_care/img2.webp";
import c4Img3 from "../assets/projects/global_care/img3.webp";
import c4Img4 from "../assets/projects/global_care/img4.webp";
import c4Img5 from "../assets/projects/global_care/img5.webp";
import c4Img6 from "../assets/projects/global_care/img6.webp";
import c4Img7 from "../assets/projects/global_care/img7.webp";
import c4Img8 from "../assets/projects/global_care/img8.webp";

//MACHO SALOON
import c5Img1 from "../assets/projects/macho_saloon/img1.webp";
import c5Img2 from "../assets/projects/macho_saloon/img2.webp";
import c5Img3 from "../assets/projects/macho_saloon/img3.webp";
import c5Img4 from "../assets/projects/macho_saloon/img4.webp";
import c5Img5 from "../assets/projects/macho_saloon/img5.webp";
import c5Img6 from "../assets/projects/macho_saloon/img6.webp";
import c5Img7 from "../assets/projects/macho_saloon/img7.webp";
import c5Img8 from "../assets/projects/macho_saloon/img8.webp";

//MAYAAS HOSTEL
import c6Img1 from "../assets/projects/mayaas_hostel/img1.webp";
import c6Img2 from "../assets/projects/mayaas_hostel/img2.webp";
import c6Img3 from "../assets/projects/mayaas_hostel/img3.webp";
import c6Img4 from "../assets/projects/mayaas_hostel/img4.webp";
import c6Img5 from "../assets/projects/mayaas_hostel/img5.webp";
import c6Img6 from "../assets/projects/mayaas_hostel/img6.webp";
import c6Img7 from "../assets/projects/mayaas_hostel/img7.webp";

//MIRTHRAN HOME CENTER
import c7Img1 from "../assets/projects/mithran_home_center/img1.webp";
import c7Img2 from "../assets/projects/mithran_home_center/img2.webp";
import c7Img3 from "../assets/projects/mithran_home_center/img3.webp";
import c7Img4 from "../assets/projects/mithran_home_center/img4.webp";
import c7Img5 from "../assets/projects/mithran_home_center/img5.webp";
import c7Img6 from "../assets/projects/mithran_home_center/img6.webp";
import c7Img7 from "../assets/projects/mithran_home_center/img7.webp";
import c7Img8 from "../assets/projects/mithran_home_center/img8.webp";
import c7Logo from "../assets/projects/mithran_home_center/logo.webp";

//OXFORD CLOTHING
import c8Img1 from "../assets/projects/oxford_clothing/img1.webp";
import c8Img2 from "../assets/projects/oxford_clothing/img2.webp";
import c8Img3 from "../assets/projects/oxford_clothing/img3.webp";
import c8Img4 from "../assets/projects/oxford_clothing/img4.webp";
import c8Img5 from "../assets/projects/oxford_clothing/img5.webp";
import c8Img6 from "../assets/projects/oxford_clothing/img6.webp";
import c8Img7 from "../assets/projects/oxford_clothing/img7.webp";
import c8Img8 from "../assets/projects/oxford_clothing/img8.webp";
import c8Img9 from "../assets/projects/oxford_clothing/img9.webp";
import c8Img10 from "../assets/projects/oxford_clothing/img10.webp";
import c8Img11 from "../assets/projects/oxford_clothing/img11.webp";

//PARAMOUNT CLOTHING
import c9Img1 from "../assets/projects/paramount_clothing/img1.webp";
import c9Img2 from "../assets/projects/paramount_clothing/img2.webp";
import c9Img3 from "../assets/projects/paramount_clothing/img3.webp";
import c9Img4 from "../assets/projects/paramount_clothing/img4.webp";
import c9Img5 from "../assets/projects/paramount_clothing/img5.webp";
import c9Img6 from "../assets/projects/paramount_clothing/img6.webp";
import c9Logo from "../assets/projects/paramount_clothing/logo.webp";

//STYLO
import c10Img1 from "../assets/projects/stylo/img1.webp";
import c10Img2 from "../assets/projects/stylo/img2.webp";
import c10Img3 from "../assets/projects/stylo/img3.webp";
import c10Img4 from "../assets/projects/stylo/img4.webp";
import c10Img5 from "../assets/projects/stylo/img5.webp";
import c10Img6 from "../assets/projects/stylo/img6.webp";

const RESIDENTIAL = "Residential";
const COMMERCIAL = "Commercial";
const OFFICE_SPACE = "Office Space";

export const residentialProject = [
  {
    id: "r1",
    name: "AR RESIDENCE",
    location: "ECR, Chennai, India",
    type: RESIDENTIAL,
    // images: [r1Img1, r1Img2, r1Img3],
    images: [r1Img2, r1Img1, r1Img3],
    coverImg: r1Img1,
    year: "2024",
    area: "5440 SQFT",
    scope: "Facade Elevation Design",
    description: `AR Residence Elevation showcases a contemporary façade design created in 2024 for a 5,440 sq ft residence in ECR, Chennai. The project blends modern aesthetics with refined detailing, emphasizing clean lines, balanced proportions, and a strong architectural identity that enhances both the visual appeal and functional character of the home.`,
  },
  {
    id: "r2",
    name: "CHANDRA STORES",
    location: "Kodambakkam, Chennai, India",
    type: RESIDENTIAL,
    images: [
      r2Img1,
      r2Img2,
      r2Img3,
      r2Img4,
      r2Img5,
      r2Img6,
      r2Img7,
      r2Img8,
      r2Img9,
    ],
    coverImg: r2Img9,
    year: "2024",
    area: "1200 SQFT",
    scope: "Interior Design, Execution",
    description: `Chandra Stores features a thoughtfully crafted interior design completed in 2024, transforming 1200 sq ft into a functional and visually appealing retail environment. The project focuses on efficient space planning, clean detailing, and seamless execution to elevate customer experience and enhance the store’s overall identity.`,
  },
  {
    id: "r3",
    name: "COIMBATORE ELEVATION",
    location: "RS puram, India",
    type: RESIDENTIAL,
    images: [r3Img4, r3Img1, r3Img2, r3Img5, r3Img6],
    coverImg: r3Img4,
    year: "2023",
    area: "2225 SQFT ",
    scope: "Planning, Interior & Exterior",
    description: `Coimbatore Elevation is a comprehensive project completed in 2023, covering planning, interior, and exterior development for a 2225 sq ft property in RS Puram. The design integrates modern aesthetics with practical functionality, ensuring cohesive spatial flow and a refined architectural character across the entire residence.`,
  },
  {
    id: "r4",
    name: "EGMORE LIVING",
    location: "Egmore, Chennai, Tamil Nadu",
    type: RESIDENTIAL,
    images: [r4Img1, r4Img2, r4Img4, r4Img3],
    coverImg: r4Img4,
    year: "2023",
    area: "1320 SQFT",
    scope: "Interior Design, Execution",
    description: `Egmore Living presents a refined 2023 interior design project spanning 1320 sq ft, focused on creating a warm, functional, and modern home environment. The execution emphasizes thoughtful material selection, efficient space usage, and curated detailing to enhance comfort and elevate everyday living experiences.`,
  },
  {
    id: "r5",
    name: "GAVIN RESIDENCE",
    location: "SURAPET, CHENNAI",
    type: RESIDENTIAL,
    images: [
      r5Img1,
      r5Img2,
      r5Img3,
      r5Img4,
      r5Img5,
      r5Img6,
      r5Img7,
      r5Img8,
      r5Img9,
      r5Img10,
    ],
    coverImg: r5Img1,
    year: "2022",
    area: "4394 sqft",
    scope: "Interior Design & Execution",
    description: `This project for Gavin showcases a chic contemporary modern design that blends clean lines with refined elegance. The space is shaped using a neutral palette, warm textures, and thoughtfully placed lighting to create depth and comfort. Modern furnishing and subtle architectural detailing highlight sophistication without overpowering the environment.`,
  },
  {
    id: "r6",
    name: "NAM ILLAM TIRCHY",
    location: "Tirichy, Tamil Nadu, India",
    type: RESIDENTIAL,
    images: [
      r6Img1,
      r6Img2,
      r6Img3,
      r6Img4,
      r6Img5,
      r6Img6,
      r6Img7,
      r6Img13,
      r6Img8,
      r6Img9,
      r6Img10,
      r6Img11,
      r6Img12,
    ],
    coverImg: r6Img13,
    year: "2024",
    area: "8200 SQFT",
    scope: "Interior Design & Execution",
    description: `Nam Illam features a spacious 4220 sq ft interior design completed in 2024. The layout blends comfort with refined detailing, ensuring functional zoning, warm aesthetics, and seamless execution to create a harmonious residential environment tailored for modern family living.`,
  },
  {
    id: "r7",
    name: "PANDIAN RESIDENCE",
    location: "Surapet, Chennai, Tamil Nadu",
    type: RESIDENTIAL,
    images: [
      r7Img1,
      r7Img2,
      r7Img3,
      r7Img4,
      r7Img5,
      r7Img6,
      r7Img7,
      r7Img8,
      r7Img9,
      r7Img10,
    ],
    coverImg: r7Img1,
    year: "2022",
    area: "2450 SQFT",
    scope: "Interior Design & Execution",
    description: `Pandian Residence features a 2450 sq ft interior design completed in 2022, focusing on comfort, space optimization, and refined detailing. The execution blends functionality with warm aesthetics, creating a cohesive and inviting home environment tailored for modern family living and long-term usability.`,
  },
  {
    id: "r8",
    name: "RAJA VILLA",
    location: "Kodambakkam, Chennai, Tamil Nadu",
    type: RESIDENTIAL,
    images: [
      r8Img1,
      r8Img2,
      r8Img3,
      r8Img4,
      r8Img5,
      r8Img6,
      r8Img7,
      r8Img8,
      r8Img9,
      r8Img10,
      r8Img11,
      r8Img12,
    ],
    coverImg: r8Img1,
    year: "###",
    area: "3240 SQFT",
    scope: "Planning, Interior & Exterior",
    description: `Raja Villa is a comprehensive 3240 sq ft project planned for 2025, integrating architecture, interiors, and exterior design. The approach focuses on balanced proportions, functional layouts, and sophisticated detailing, resulting in a cohesive home that blends elegance, comfort, and strong architectural presence.`,
  },
  {
    id: "r9",
    name: "FAYAZ RES",
    location: "Nesapakkam, Chennai, India",
    type: COMMERCIAL,
    images: [c2Img1, c2Img2, c2Img3, c2Img4],
    coverImg: c2Img1,
    year: "2023",
    area: "900 SQFT",
    scope: "Interior Design & Execution",
    description: `Fayaz Residence showcases a warm, contemporary interior design completed in 2023 across 1100 sq ft. The layout prioritizes comfort, space optimization, and elegant detailing, delivering a well-executed residential environment that enhances everyday living through thoughtful material choices and a balanced visual identity.`,
  },
];

export const officeSpaceProjects = [
  {
    id: "o1",
    name: "ELEVATE STUIDOS",
    location: "Kodambakkam, Chennai, India",
    type: OFFICE_SPACE,
    images: [
      o1Img1,
      o1Img2,
      o1Img3,
      o1Img4,
      o1Img5,
      o1Img6,
      o1Img7,
      o1Img8,
      o1Img9,
      o1Img10,
    ],
    coverImg: o1Img10,
    year: "2023",
    area: "1100 SQFT",
    scope: "Interior Design, Execution",
    description: `Elevate Studios features a modern interior design crafted in 2023 for an 1100 sq ft space. The project focuses on functional planning, clean aesthetics, and seamless execution, creating an efficient and visually cohesive environment tailored for productivity and a refined studio experience.`,
    testimonialLogo: o1Logo,
    testimonialBorderColor: "#233a1e",
    testimonialContent: `  Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quisquam amet est tempora totam quis, quod eos modi eius asperiores.`,
  },
  {
    id: "o2",
    name: "MIRACLE WEDDING",
    location: "Kodambakkam, Chennai, Tamil Nadu",
    type: OFFICE_SPACE,
    images: [o2Img1, o2Img2, o2Img3, o2Img4, o2Img5, o2Img6, o2Img7],
    coverImg: o2Img2,
    year: "2025",
    area: "1360 SQFT",
    scope: "Planning, Interior & Exterior",
    description: `Miracle Wedding integrates planning, interior, and exterior design across 1360 sq ft in 2025. The project combines elegant aesthetics with functional spaces, creating a warm and celebratory environment that enhances workflow, visual identity, and the overall guest experience for wedding-related services.`,
    testimonialLogo: o2Logo,
    testimonialBorderColor: "#cd819f",
    testimonialContent: `  Render X Architects redesigned our studio interior beautifully. The space feels modern, functional, and perfectly suited to our work. We truly loved the result.`,
  },
  {
    id: "o3",
    name: "STILT OFFICE",
    location: "koyembedu, Chennai, India",
    type: OFFICE_SPACE,
    images: [o3Img1, o3Img2, o3Img3, o3Img4, o3Img5, o3Img6, o3Img7],
    coverImg: o3Img3,
    year: "2023",
    area: "1280 SQFT",
    scope: "Interior Design & Execution",
    description: `Stilt Office delivers a smart 1280 sq ft workspace design completed in 2023. The interior focuses on productivity, clean aesthetics, and smooth circulation, with thoughtful materials and detailing that create a functional, modern office environment supporting efficient day-to-day operations.`,
  },
];

export const commercialProjects = [
  {
    id: "c1",
    name: "EXPERIENCE CENTER",
    location: "Kodambakkam, Chennai, India",
    type: COMMERCIAL,
    images: [c1Img1, c1Img3, c1Img2, c1Img4, c1Img5],
    coverImg: c1Img2,
    year: "2025",
    area: "620 SQFT",
    scope: "Interior Design & Execution",
    description: `The Experience Center, designed in 2025, transforms 620 sq ft into a highly functional and immersive space. The interior design focuses on refined detailing, intuitive circulation, and brand-centric aesthetics, delivering a compact yet impactful environment that enhances user interaction and overall visitor experience through seamless execution.`,
  },

  {
    id: "c3",
    name: "FEALZ",
    location: "Anna Nagar, Chennai, India",
    type: COMMERCIAL,
    images: [
      c3Img1,
      c3Img2,
      c3Img3,
      c3Img4,
      c3Img5,
      c3Img6,
      c3Img7,
      c3Img8,
      c3Img9,
    ],
    coverImg: c3Img1,
    year: "2024",
    area: "820 SQFT",
    scope: "Planning, Interior & Exterior",
    description: `Fealz presents a sleek and modern 1100 sq ft interior design executed in 2024. The project blends minimal aesthetics with practical functionality, ensuring efficient space usage, stylish detailing, and a cohesive environment suited for both comfort and contemporary lifestyle needs.`,
  },
  {
    id: "c4",
    name: "GLOBAL CRITICAL CARE",
    location: "Dharmapuri, Tamil Nadu, India",
    type: COMMERCIAL,
    images: [c4Img1, c4Img2, c4Img3, c4Img4, c4Img5, c4Img6, c4Img7, c4Img8],
    coverImg: c4Img1,
    year: "2022",
    area: "3250 SQFT",
    scope: "Interior Design & Execution",
    description: `Global Critical Care Hospital’s 2022 interior design spans 3250 sq ft, delivering a well-planned healthcare environment focused on clarity, hygiene, and efficiency. The execution emphasizes functional zoning, patient comfort, and modern detailing to support smooth operations and create a reassuring medical ambience.`,
  },
  {
    id: "c5",
    name: "MACHO SALOON",
    location: "Kodambakkam, Chennai, India",
    type: COMMERCIAL,
    images: [c5Img1, c5Img2, c5Img3, c5Img4, c5Img5, c5Img6, c5Img7, c5Img8],
    coverImg: c5Img1,
    year: "2022",
    area: "820 SQFT",
    scope: "Interior Design & Execution",
    description: `Macho Saloon features a stylish 820 sq ft interior design completed in 2022. The layout maximizes compact space with smart planning, bold aesthetics, and clean execution, creating a modern grooming environment that enhances customer experience and reflects a strong brand personality.`,
  },
  {
    id: "c6",
    name: "MAYAAS HOSTEL",
    location: "Potheri, Chennai, India",
    type: COMMERCIAL,
    images: [c6Img1, c6Img2, c6Img3, c6Img4, c6Img5, c6Img6, c6Img7],
    coverImg: c6Img1,
    year: "2025",
    area: "3250 SQFT",
    scope: "Interior Design & Execution",
    description: `Mayaas Hostel is a 3250 sq ft project designed in 2025 to offer comfortable, functional student living. The interior layout optimizes shared and private spaces, ensures durability, and blends clean aesthetics with practical execution to create a modern, efficient hostel environment.`,
  },
  {
    id: "c7",
    name: "MITHRAN HOME CENTER",
    location: "Guduvanchery, Chennai, India",
    type: COMMERCIAL,
    images: [c7Img8, c7Img1, c7Img2, c7Img3, c7Img4, c7Img5, c7Img6, c7Img7],
    coverImg: c7Img8,
    year: "2024",
    area: "8200 SQFT",
    scope: "Exterior Elevation & Interior Design",

    description: `Mithran Home Center spans 8200 sq ft with a 2024 design covering both exterior elevation and interiors. The project emphasizes a strong visual identity, efficient retail planning, and cohesive detailing, delivering a modern commercial environment that balances aesthetics, clarity, and customer-friendly functionality`,
    testimonialLogo: c7Logo,
    testimonialBorderColor: "#602a7a",
    testimonialContent: `Render X Architects transformed our store with beautiful exterior elevation and interior design. Everything looked modern, well-planned, and perfectly matched our brand.  `,
  },
  {
    id: "c8",
    name: "OXFORD CLOTHING",
    location: "Anna Nagar, Chennai, India",
    type: COMMERCIAL,
    images: [
      c8Img1,
      c8Img2,
      c8Img3,
      c8Img4,
      c8Img5,
      c8Img6,
      c8Img7,
      c8Img8,
      c8Img9,
      c8Img10,
      c8Img11,
    ],
    coverImg: c8Img1,
    year: "2024",
    area: "1320 SQFT",
    scope: "Exterior Elevation & Interior Design",
    description: `Oxford Clothing’s 1320 sq ft interior design, completed in 2024, blends modern retail aesthetics with efficient space planning. The project emphasizes product visibility, clean detailing, and smooth customer flow, resulting in a stylish and well-executed store environment that elevates the brand’s identity and enhances the shopping experience.`,
  },
  {
    id: "c9",
    name: "PARAMOUNT CLOTHING",
    location: "MMDA, Chennai, India",
    type: COMMERCIAL,
    images: [c9Img1, c9Img2, c9Img3, c9Img4, c9Img5, c9Img6],
    coverImg: c9Img1,
    year: "2024",
    area: "750 SQFT",
    scope: "Exterior Elevation & Interior Design",
    description: `Paramount Clothing’s 2024 design transforms 750 sq ft through a striking exterior elevation and modern interior layout. The project emphasizes brand visibility, efficient space planning, and clean detailing, creating a contemporary retail environment that enhances customer experience and reinforces a strong, stylish store identity.`,
    testimonialLogo: c9Logo,
    testimonialBorderColor: "black",
    testimonialContent: `  Render X Architects designed our store beautifully. The exterior and interior came out better than we imagined, and the whole process felt smooth and professional.`,
  },

  {
    id: "c10",
    name: "STYLO",
    location: "Porur, Chennai, India",
    type: COMMERCIAL,
    images: [c10Img1, c10Img2, c10Img3, c10Img4, c10Img5, c10Img6],
    coverImg: c10Img1,
    year: "2023",
    area: "1490 SQFT",
    scope: "Exterior Elevation & Interior Design",
    description: `Stylo’s 1490 sq ft project blends elegant exterior elevation with contemporary interior design. Completed in 2023, the design enhances brand presence through modern aesthetics, strategic layout, and refined detailing, resulting in a cohesive retail environment that elevates both visual appeal and customer engagement.`,
  },
];

export const projectsData = [
  ...residentialProject,
  ...officeSpaceProjects,
  ...commercialProjects,
];

export const getProjectById = (id) => {
  return projectsData.find((project) => project.id === id) || null;
};
